import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1ae0b5e9"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae0b5e9')) {
      api.createRecord('1ae0b5e9', component.options)
    } else {
      api.reload('1ae0b5e9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1ae0b5e9", function () {
      api.rerender('1ae0b5e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/education/index.vue"
export default component.exports